type TreeNode = {
  id: string;
  label: string;
  documentCount?: number;
  children?: TreeNode[];
  [key: string]: any;
};

export const transformTreeData = (nodes: TreeNode[]): TreeNode[] => {
  return nodes.map((node) => {
    const hasChildren = node.children && node.children.length > 0;
    const count = node.documentCount ?? 0;

    return {
      ...node,
      ...(hasChildren ? {skipParent: true} : {}),
      ...(count < 1 || count >= 250 ? {disabled: true} : {}),
      children: hasChildren ? transformTreeData(node.children!) : [],
    };
  });
};

/**
 * Converts an uppercase string to capitalized format
 * (first letter uppercase, rest lowercase).
 *
 * @param value Uppercase string (e.g., 'DRAFTED')
 * @returns Capitalized string (e.g., 'Drafted')
 */
export function toCapitalized(value: unknown): string {
  if (typeof value !== 'string') return '';

  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

export const RELEVANCY_COLUMN_MAP: Record<string, string> = {
  relevancy: 'Relevancy',
  groundTruthRelevancy: 'GroundTruth',
  reason: 'Reason',
  excerpt: 'Excerpt',
};

export const ISSUE_CODE_COLUMN_MAP: Record<string, string> = {
  issueCode: 'ISSUECODE',
  question: 'QUESTION',
  relevantDocCount: 'RELEVENCY',
  nonRelevantDocCount: 'NONRELEVENCY',
};
export interface IJobGroup {
  name: string;
  jobGroupId: number;
  count: number;
  isSelected: boolean;
}
